module.exports = __webpack_public_path__ + "img/burshtat_mob_portfolio_4_2x.1d626e9d.png";